import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { env, http } from '../common';
export function getUserTitleList(data, config) {
  return __awaiter(this, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , http(__assign({
            url: 'title/queryUserTitlePageByCondition',
            data: data,
            auth: true
          }, config))];

        case 1:
          res = _a.sent();

          try {
            if (env.uid && Number(res.code) === 200 && res.data) {
              localStorage.setItem("titleList_" + env.uid, JSON.stringify(res));
            }
          } catch (e) {}

          return [2
          /*return*/
          , res];
      }
    });
  });
}
export function addSharedTitle(data, config) {
  return http(__assign({
    url: 'title/addSharedTitle',
    data: data,
    auth: true
  }, config));
}
export function deleteTitle(data, config) {
  return http(__assign({
    url: 'title/deleteUserTitle',
    data: data,
    auth: true
  }, config));
}
export function updateDefaultTitle(data, config) {
  return http(__assign({
    url: 'title/setUserDefaultTitle',
    data: data,
    auth: true
  }, config));
}
export function getTitleDetail(data, config) {
  return http(__assign({
    url: 'title/getUserTitleDetail',
    data: data,
    auth: true
  }, config));
}
export function queryTitleSpecialInfo(data, config) {
  return http(__assign({
    url: 'title/queryTitleSpecialInfo',
    data: data,
    auth: true,
    toastType: 'hide'
  }, config));
} // 专票精准搜索抬头

export function queryTitleInfo(data, config) {
  return http(__assign({
    url: 'title/queryTitleInfo',
    data: data,
    auth: true,
    toastType: 'hide'
  }, config));
}
export function addTitle(data, config) {
  return http(__assign({
    url: 'title/addUserTitle',
    data: data,
    auth: true
  }, config));
}
export function updateTitle(data, config) {
  return http(__assign({
    url: 'title/updateUserTitle',
    data: data,
    auth: true
  }, config));
}
export function suggestTitle(data, config) {
  return http(__assign({
    url: 'title/queryTitleSuggest',
    data: data,
    auth: true
  }, config));
}
export function userOperationCallback(data, config) {
  return http(__assign({
    url: 'title/userTitleOperationCallback',
    data: data,
    auth: true
  }, config));
}
export function querySharedTitleDetail(data, config) {
  return http(__assign({
    url: 'title/querySharedTitleDetail',
    data: data,
    auth: false
  }, config));
}
export function isCheckInvoiceNotice(data, config) {
  return http(__assign({
    url: 'auth/isCheckInvoiceNotice',
    data: data,
    auth: true
  }, config));
}
export function checkInvoiceNoticeComplete(data, config) {
  return http(__assign({
    url: 'auth/checkInvoiceNoticeComplete',
    data: data,
    auth: true
  }, config));
}